import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SignupService } from '../../services/signup.service';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import {
  FacebookService,
  InitParams,
  LoginResponse,
  LoginOptions,
} from 'ngx-facebook';
import { WatcherService } from 'src/app/services/watcher.service';
import { MetaPixelService } from 'src/app/services/metapixel.service';
import firebase from 'firebase/compat/app';
import { InvisibleReCaptchaComponent } from 'ngx-captcha';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import * as AuthActions from '../../store/shared/auth/auth.actions';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { ViewportScroller } from '@angular/common';
import { combineLatest } from 'rxjs';
import { ForgotMyPasswordDialog } from './forgot-my-password-dialog/forgot-my-password-dialog';
import { MatDialog } from '@angular/material/dialog';
import { getAuth, signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
declare var grecaptcha: any;
interface SignInResponse {
  result: {
    status: number;
    message: string;
  };
  data: {
    token: string;
    user: {
      email: string;
      is_email_verified: boolean;
      is_phone_verified: boolean;
      id: string;
      type: number;
      campaign?: string;
      user_profile?: {
        banner_image?: string;
      };
    };
    payment_methods?: Array<{
      type: string;
      status: string;
    }>;
  };
}
declare var $;
@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css'],
})
export class SigninComponent implements OnInit, OnDestroy {
  facebookLoginErrorMessage;
  recaptchaCheckboxKey = "6LfzUlUaAAAAAKKv0UBaepUWBOJKiZ62xqtvqREh";
  googleRecapthaSiteKey = '6LfMx2sqAAAAALozJ2v3YtBgHntNr4AfUGCUL23_';
  recaptcha;
  passingSignupData = false;
  socialLoginToken;
  form = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    password: new UntypedFormControl('', Validators.required),
    recaptcha: new UntypedFormControl('', Validators.required),
  });
  forgotPasswordForm = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    forgotPassRecaptcha: new UntypedFormControl('', Validators.required),
  });

  socialUpdateForm = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
  });
  isWebview = () => {
    if (typeof window === undefined) {
      return false;
    }
    let navigator: any = window.navigator;
    const standalone = navigator.standalone;
    const userAgent = navigator.userAgent.toLowerCase();
    const safari = /safari/.test(userAgent);
    const ios = /iphone|ipod|ipad/.test(userAgent);
    return ios ? !standalone && !safari : userAgent.includes('wv');
  };
  isAndrodiWebview = () => {
    let isWebView = false;
    let userAgent = navigator.userAgent;
    if (/Android/.test(userAgent)) {
      var androidVersion = parseFloat(
        userAgent.slice(userAgent.indexOf('Android') + 8)
      );
      if (androidVersion >= 10) {
        isWebView = /(wv)/.test(userAgent);
      } else {
        isWebView = userAgent.includes('Version/');
      }
    }
    if (isWebView) {
      return true;
    } else {
      return false;
    }
  };

  constructor(
    private route: ActivatedRoute,
    public signUpService: SignupService,
    public router: Router,
    private toastr: ToastrService,
    private $gaService: GoogleAnalyticsService,
    private fb: FacebookService,
    private watcherService: WatcherService,
    private metaPixelService: MetaPixelService,
    private store: Store<AppState>,
    private gtmService: GoogleTagManagerService,
    private vps: ViewportScroller,
    private dialog: MatDialog
  ) {
    const initParams: InitParams = {
      appId: '558848698455833',
      status: true,
      cookie: true,
      xfbml: true,
      version: 'v17.0',
    };
    fb.init(initParams);
  }

  lang;
  platformisWebView = false;
  @ViewChild('captchaElem') captchaElem: InvisibleReCaptchaComponent;
  initScrollPosition() {
    this.vps.scrollToPosition([0, 0]);
  }
  resetCaptcha() {
    this.captchaElem.resetCaptcha();
  }
  onCaptchaExpired() {
    this.resetCaptcha();
  }
  ngOnInit(): void {
    if (this.isAndrodiWebview() || this.isWebview()) {
      this.platformisWebView = true;
    }
    this.watcherService.getLang().subscribe((lang) => {
      this.lang = lang;
      this.lang = lang;
    });
    let bfm_shopper_id = localStorage.getItem('bfm_shopper_id');
    let orderUserID = localStorage.getItem('orderDetailUserId');
    let lsCachedUser = JSON.parse(localStorage.getItem('CACHED_USER'));
    if (
      lsCachedUser &&
      lsCachedUser.id != null &&
      (bfm_shopper_id != null || orderUserID != null) &&
      (bfm_shopper_id == lsCachedUser.id || orderUserID == lsCachedUser.id)
    ) {
      this.toastr.error('Your session is expired please sign in again.');
    }
  }
  checkInputValidations() {
    var hasError = false;
    if (this.form.controls.email.status == 'INVALID') {
      this.form.controls.email.markAsTouched();
      hasError = true;
    }
    if (this.form.controls.password.status == 'INVALID') {
      this.form.controls.password.markAsTouched();
      hasError = true;
    }
    if (this.form.controls.recaptcha.status == 'INVALID') {
      this.form.controls.recaptcha.markAsTouched();
      hasError = true;
    }
    return hasError;
  }
  handleError() { }
  signIn() {
    if (!this.checkInputValidations()) {
      this.passingSignupData = true;
      const recaptcha = {
        action: 'LOGIN',
        token: this.form.value.recaptcha,
      }
      this.signUpService
        .signIn(
          this.form.value.email.toLowerCase(),
          this.form.value.password,
          recaptcha
        )
        .subscribe({
          next: (data: SignInResponse) => {
            if (data?.result?.status === 200) {
              this.handleSuccessfulSignIn(data);
            } else {
              this.toastr.error(data?.result?.message || 'An error occurred', 'Error');
              this.passingSignupData = false;
              this.handleReset();
            }
          },
          error: (err) => {
            this.passingSignupData = false;
            this.toastr.error('An error occurred');
            this.handleReset();
          },
        });
    }
  }
  handleSuccessfulSignIn(data) {
    const user = data.data.user;
    const token = data.data.token;
    this.gtmService.pushTag({
      event: 'gtmSignIn',
      data: { email: user.email },
    });
    this.storeLoginData(data);
    this.store.dispatch(AuthActions.LoginSuccess({ token, user }));
    this.$gaService.event('sign_in', 'sign_in', user.email);
    this.storePaymentVerification(data.data.payment_methods);
    this.routeAfterLogin(user, token);
  }
  storeLoginData(data) {
    localStorage.setItem('token', data.data.token);
    localStorage.setItem('is_email_verified', data.data.user.is_email_verified);
    localStorage.setItem('userId', data.data.user.id);
    localStorage.setItem('is_phone_verified', data.data.user.is_phone_verified);
    localStorage.setItem('CACHED_USER', JSON.stringify(data.data.user));
  }
  storePaymentVerification(paymentMethods) {
    const isPaypalVerified = paymentMethods?.some(
      (method) => method.type === 'paypal' && method.status === 'VERIFIED'
    );
    localStorage.setItem('paypal_verified', isPaypalVerified ? 'true' : 'false');
  }
  routeAfterLogin(user, token) {
    const { anonymous_id, cart_id, bfm_country_from, bfm_country_to, bfm_shopper_id } = this.getLocalStorageData();
    const userType = user.type;
    const sessionUserId = user.id;
    const orderID = localStorage.getItem('orderDetailID');
    const orderUserID = localStorage.getItem('orderDetailUserId');
    if (!user.is_phone_verified || !user.is_email_verified) {
      this.redirectUnverifiedUser(user);
    } else {
      this.route.queryParams.subscribe((params) => {
        if (params.anonymous_id && params.cart_id) {
          this.router.navigate(['/', this.lang, 'bfm'], {
            queryParams: { anonymous_id: params.anonymous_id, cart_id: params.cart_id },
          });
        } else {
          this.handleUserTypeRouting(user, token, orderID, orderUserID, sessionUserId, userType);
        }
      });
    }
  }
  redirectUnverifiedUser(user) {
    const route = user.campaign === 'Better-Brands'
      ? ['/', this.lang, 'campaigns', 'better-brands']
      : ['/', this.lang, 'verification'];
    return this.router.navigate(route);
  }

  handleUserTypeRouting(user, token, orderID, orderUserID, sessionUserId, userType) {
    if (userType === 1) {
      this.handleShopperRouting(token, user.id, orderID, orderUserID, sessionUserId);
    } else if (userType === 5) {
      this.router.navigate(['/', this.lang, 'b2b', 'shipments']);
    } else if (userType === 4) {
      this.handleAffiliateRouting(user);
    } else {
      this.router.navigate(['/', this.lang, 'home']);
    }
  }

  handleShopperRouting(token: string, userID: string, orderID: string, orderUserID: string, sessionUserId: string) {
    const mailboxPacks$ = this.signUpService.getShopperOrderListByStatus(token, userID, '3,4,5,6,7');
    const expectedPacks$ = this.signUpService.getShopperOrderListByStatus(token, userID, '1');
    combineLatest([mailboxPacks$, expectedPacks$]).subscribe(([mailboxPacks, expectedPacks]: [any, any]) => {
      if (mailboxPacks.data?.length > 0) {
        this.router.navigate(['/', this.lang, 'member', 'packs-mailbox']);
      } else {
        const hasTrackingIssue = expectedPacks.data?.some(
          (e) => !e.tracking_from_to_host || e.tracking_from_to_host.trim() === ''
        );
        const route = hasTrackingIssue
          ? ['/', this.lang, 'member', 'packs-expected']
          : ['/', this.lang, 'home'];
        this.router.navigate(route);
      }
    });
  }

  handleAffiliateRouting(user) {
    const hasBannerImage = user.user_profile?.banner_image?.length > 1;
    const route = hasBannerImage
      ? ['/', this.lang, 'member', 'affiliate-dashboard']
      : ['/', this.lang, 'become-an-affiliate'];
    this.router.navigate(route);
  }

  getLocalStorageData() {
    return {
      anonymous_id: localStorage.getItem('anonymous_id'),
      cart_id: localStorage.getItem('cart_id'),
      bfm_country_from: localStorage.getItem('bfm_country_from'),
      bfm_country_to: localStorage.getItem('bfm_country_to'),
      bfm_shopper_id: localStorage.getItem('bfm_shopper_id'),
    };
  }
  handleReset() {
    this.captchaElem.resetCaptcha();
  }
  handleReady() {
    this.captchaElem.reloadCaptcha();
  }
  forgotPasswordValidation() {
    var hasError = false;
    if (this.forgotPasswordForm.controls.email.status == 'INVALID') {
      this.forgotPasswordForm.controls.email.markAsTouched();
      hasError = true;
    }
    if (this.form.controls.recaptcha.status == 'INVALID') {
      this.form.controls.recaptcha.markAsTouched();
      this.toastr.error('Recaptcha Error');
      hasError = true;
    }
    return hasError;
  }
  socialUpdateValidation() {
    var hasError = false;
    if (this.socialUpdateForm.controls.email.status == 'INVALID') {
      this.socialUpdateForm.controls.email.markAsTouched();
      hasError = true;
    }
    return hasError;
  }
  forgotPassword() {
    const recaptcha = {
      action: 'FORGOT_PASSWORD',
      token: this.token,
    }
    if (this.forgotPasswordValidation() == false) {
      var userData = {
        email: this.forgotPasswordForm.value.email,
        recaptcha_token: recaptcha
      };
      this.signUpService.forgotPassword(userData).subscribe({
        next: (data) => {
          if (data['result']['status'] == 200) {
            this.toastr.success(data['result']['message'], 'Success');
            $('#forgotPasswordModal').modal('hide');
            this.forgotPasswordForm.reset();
          } else {
            this.toastr.error(data['result']['message'], 'Error');
            this.handleReset();
          }
        },
        error: (err) => {
          this.handleReset();
        },
      });
    }
  }
  loginWithFacebook(): void {
    document.getElementById('facebookLoginStatusModalBtn').click();

    let loginOptions: LoginOptions = {
      scope: 'email',
    };

    this.fb
      .login(loginOptions)
      .then((response: LoginResponse) => {
        var userData = {
          access_token: response.authResponse.accessToken,
          facebook_user_id: response.authResponse.userID,
          type: 1,
        };
        this.signUpService.signUpwithFacebook(userData).subscribe((data) => {
          if (data['result']['status'] == 200) {
            const gtmTag = {
              event: 'gtmSignIn',
              data: { email: data['data'].user.email },
            };
            this.gtmService.pushTag(gtmTag);
            localStorage.setItem('token', data['data']['token']);
            localStorage.setItem(
              'is_email_verified',
              data['data']['user']['is_email_verified']
            );
            localStorage.setItem('userId', data['data']['user']['id']);
            localStorage.setItem(
              'is_phone_verified',
              data['data']['user']['is_phone_verified']
            );
            localStorage.setItem(
              'CACHED_USER',
              JSON.stringify(data['data']['user'])
            );
            // //this.metaPixelService.onSignUpEvent(data['data'].user.email);
            this.$gaService.event(
              'sign_in',
              'sign_in',
              data['data']['user']['email']
            );
            document.getElementById('facebookLoginCloseModalBtn').click();
            // If user session was ended in BFM Checkout Redirect user to BFM Checkout
            let anonymous_id = localStorage.getItem('anonymous_id');
            let cart_id = localStorage.getItem('cart_id');
            let bfm_country_from = localStorage.getItem('bfm_country_from');
            let bfm_country_to = localStorage.getItem('bfm_country_to');
            let bfm_shopper_id = localStorage.getItem('bfm_shopper_id');
            let userType = data['data']['user']['type'];
            let isPhoneVerified = data['data']['user']['is_phone_verified'];
            let isEmailVerified = data['data']['user']['is_email_verified'];
            let sessionUserId = data['data']['user']['id'];

            let user: object = data['data']['user'];
            this.store.dispatch(
              AuthActions.LoginSuccess({ token: data['data']['token'], user })
            );
            if (
              data['data']['user']['type'] === 5 &&
              data['data']['user']['is_b2b_user_active']
            ) {
              this.signUpService
                .listB2BShipmentsViaUserID(
                  data['data']['token'],
                  data['data']['user']['id']
                )
                .subscribe({
                  next: (b2bShipmentsResponse) => {
                    if (b2bShipmentsResponse['data'].length == 0) {
                      this.router.navigate([
                        '/',
                        this.lang,
                        'b2b',
                        'shipment-create',
                      ]);
                    }
                  },
                  error: (err) => {
                  },
                });
            }
            // Check if user verified
            if (
              anonymous_id &&
              cart_id &&
              userType == 1 &&
              isPhoneVerified == 1 &&
              isEmailVerified == 1 &&
              sessionUserId == bfm_shopper_id
            ) {
              this.router.navigate(['/', this.lang, 'bfm', 'checkout'], {
                queryParams: {
                  anonymous_id: anonymous_id,
                  cart_id: cart_id,
                  country_from: bfm_country_from,
                  country_to: bfm_country_to,
                  shopper_id: bfm_shopper_id,
                },
              });
            }
            // If user session was ended in BFM Checkout Redirect user to BFM Checkout
            // If user session was ended in Order Detail
            let orderID = localStorage.getItem('orderDetailID');
            let orderUserID = localStorage.getItem('orderDetailUserId');
            if (orderID && userType == 1 && orderUserID == sessionUserId) {
              this.router.navigate([
                '/',
                this.lang,
                'member',
                'order-details',
                orderID,
              ]);
            }
            this.router.navigate(['/', this.lang, 'verification']);
          } else {
            this.toastr.error(data['result']['message'], 'Error');
            //this.passingSignupData = false;
            if (data['result']['status'] == 855) {
              //this.updateSocialLoginProfile(data["data"]["token"])
              document.getElementById('facebookLoginCloseModalBtn').click();
              document.getElementById('socialUpdateModalTriggerBtn').click();
              this.socialLoginToken = data['data']['token'];
            }
          }
        });
      })
      .catch((error: any) => { });
  }
  loginWithGoogle(): void {
    const provider = new GoogleAuthProvider();
    const auth = getAuth();

    signInWithPopup(auth, provider).then((val) => {
      const credential = GoogleAuthProvider.credentialFromResult(val);
      const accessTokenFromFire = credential?.accessToken;

      const userData = {
        access_token: accessTokenFromFire,
        type: 1
      };
      this.signUpService.signUpwithGoogle(userData).subscribe((data) => {
        if (data['result']['status'] == 200) {
          const gtmTag = {
            event: 'gtmSignIn',
            data: { email: data['data'].user.email },
          };
          this.gtmService.pushTag(gtmTag);

          localStorage.setItem('token', data['data']['token']);
          localStorage.setItem(
            'is_email_verified',
            data['data']['user']['is_email_verified']
          );
          localStorage.setItem('userId', data['data']['user']['id']);
          localStorage.setItem(
            'is_phone_verified',
            data['data']['user']['is_phone_verified']
          );
          localStorage.setItem(
            'CACHED_USER',
            JSON.stringify(data['data']['user'])
          );
          // //this.metaPixelService.onSignUpEvent(data['data'].user.email);
          this.$gaService.event(
            'sign_in',
            'sign_in',
            data['data']['user']['email']
          );
          // If user session was ended in BFM Checkout Redirect user to BFM Checkout
          let anonymous_id = localStorage.getItem('anonymous_id');
          let cart_id = localStorage.getItem('cart_id');
          let bfm_country_from = localStorage.getItem('bfm_country_from');
          let bfm_country_to = localStorage.getItem('bfm_country_to');
          let bfm_shopper_id = localStorage.getItem('bfm_shopper_id');
          let userType = data['data']['user']['type'];
          let isPhoneVerified = data['data']['user']['is_phone_verified'];
          let isEmailVerified = data['data']['user']['is_email_verified'];
          let sessionUserId = data['data']['user']['id'];

          let user: object = data['data']['user'];
          this.store.dispatch(
            AuthActions.LoginSuccess({ token: data['data']['token'], user })
          );

          if (
            data['data']['user']['type'] === 5 &&
            data['data']['user']['is_b2b_user_active']
          ) {
            this.signUpService
              .listB2BShipmentsViaUserID(
                data['data']['token'],
                data['data']['user']['id']
              )
              .subscribe({
                next: (b2bShipmentsResponse) => {
                  if (b2bShipmentsResponse['data'].length == 0) {
                    this.router.navigate([
                      '/',
                      this.lang,
                      'b2b',
                      'shipment-create',
                    ]);
                  }
                },
                error: (err) => {
                },
              });
          }
          // Check if user verified
          if (
            anonymous_id &&
            cart_id &&
            userType == 1 &&
            isPhoneVerified == 1 &&
            isEmailVerified == 1 &&
            sessionUserId == bfm_shopper_id
          ) {
            this.router.navigate(['/', this.lang, 'bfm', 'checkout'], {
              queryParams: {
                anonymous_id: anonymous_id,
                cart_id: cart_id,
                country_from: bfm_country_from,
                country_to: bfm_country_to,
                shopper_id: bfm_shopper_id,
              },
            });
          }
          // If user session was ended in BFM Checkout Redirect user to BFM Checkout

          // If user session was ended in Order Detail
          let orderID = localStorage.getItem('orderDetailID');
          let orderUserID = localStorage.getItem('orderDetailUserId');
          if (orderID && userType == 1 && orderUserID == sessionUserId) {
            this.router.navigate([
              '/',
              this.lang,
              'member',
              'order-details',
              orderID,
            ]);
          }
          this.router.navigate(['/', this.lang, 'verification']);
        } else {
          this.toastr.error(data['result']['message'], 'Error');
        }
      });
    });
  }
  updateSocialLoginProfile() {
    if (this.socialUpdateValidation() == false) {
      var facebokData = {
        email: this.socialUpdateForm.value.email,
      };
      this.signUpService
        .updateUserDataForFacebookSocialLogin(
          this.socialLoginToken,
          facebokData
        )
        .subscribe((data) => {
          if (data['result']['status'] == 200) {
            const gtmTag = {
              event: 'gtmSignIn',
              data: { email: data['data'].user.email },
            };
            this.gtmService.pushTag(gtmTag);
            this.toastr.success(data['result']['message'], 'Success');
            $('#socialUpdateModal').modal('hide');
            localStorage.setItem('token', this.socialLoginToken);
            localStorage.setItem(
              'is_email_verified',
              data['data']['is_email_verified']
            );
            localStorage.setItem('userId', data['data']['id']);
            localStorage.setItem(
              'is_phone_verified',
              data['data']['is_phone_verified']
            );
            localStorage.setItem('CACHED_USER', JSON.stringify(data['data']));
            // If user session was ended in BFM Checkout Redirect user to BFM Checkout
            let anonymous_id = localStorage.getItem('anonymous_id');
            let cart_id = localStorage.getItem('cart_id');
            let bfm_country_from = localStorage.getItem('bfm_country_from');
            let bfm_country_to = localStorage.getItem('bfm_country_to');
            let bfm_shopper_id = localStorage.getItem('bfm_shopper_id');
            let userType = data['data']['user']['type'];
            let isPhoneVerified = data['data']['user']['is_phone_verified'];
            let isEmailVerified = data['data']['user']['is_email_verified'];
            let sessionUserId = data['data']['user']['id'];
            let user: object = data['data']['user'];
            this.store.dispatch(
              AuthActions.LoginSuccess({ token: data['data']['token'], user })
            );
            // Check if user verified
            if (
              anonymous_id &&
              cart_id &&
              userType == 1 &&
              isPhoneVerified == 1 &&
              isEmailVerified == 1 &&
              sessionUserId == bfm_shopper_id
            ) {
              this.router.navigate(['/', this.lang, 'bfm', 'checkout'], {
                queryParams: {
                  anonymous_id: anonymous_id,
                  cart_id: cart_id,
                  country_from: bfm_country_from,
                  country_to: bfm_country_to,
                  shopper_id: bfm_shopper_id,
                },
              });
            }
            let orderID = localStorage.getItem('orderDetailID');
            let orderUserID = localStorage.getItem('orderDetailUserId');
            if (orderID && userType == 1 && orderUserID == sessionUserId) {
              this.router.navigate([
                '/',
                this.lang,
                'member',
                'order-details',
                orderID,
              ]);
            }
            this.router.navigate(['/', this.lang, 'verification']);
          } else {
            this.toastr.error(data['result']['message'], 'Error');
          }
        });
    }
  }
  ngOnDestroy(): void {
    this.captchaElem.resetCaptcha();
  }
  token;
  captchaError: string;
  openDialog(): void {
    const dialogRef = this.dialog.open(ForgotMyPasswordDialog, {});
  }
}
